/**
 * @generated SignedSource<<aa96a60290043051d487e41a4c513ec0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TeamAdminUnarchiveTeamMutation$variables = {
  teamId: string;
};
export type TeamAdminUnarchiveTeamMutation$data = {
  readonly team: {
    readonly updateArchivedStatus: {
      readonly id: string;
      readonly isArchived: boolean;
      readonly members: ReadonlyArray<{
        readonly id: string;
      }>;
    };
  };
};
export type TeamAdminUnarchiveTeamMutation = {
  response: TeamAdminUnarchiveTeamMutation$data;
  variables: TeamAdminUnarchiveTeamMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "teamId"
      }
    ],
    "concreteType": "TeamMutation",
    "kind": "LinkedField",
    "name": "team",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "isArchived",
            "value": false
          }
        ],
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "updateArchivedStatus",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isArchived",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "members",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "updateArchivedStatus(isArchived:false)"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamAdminUnarchiveTeamMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TeamAdminUnarchiveTeamMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "3698c2c059f260b16cdfac227f591fa9",
    "id": null,
    "metadata": {},
    "name": "TeamAdminUnarchiveTeamMutation",
    "operationKind": "mutation",
    "text": "mutation TeamAdminUnarchiveTeamMutation(\n  $teamId: ID!\n) {\n  team(id: $teamId) {\n    updateArchivedStatus(isArchived: false) {\n      id\n      isArchived\n      members {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f7a29c2c9b8b2752ed0eb23a3d5e5aa5";

export default node;
